export default "__VITE_ASSET__5daca47b__"